<template>
  <div class="header">
    <div class="user-info">
      <div class="toggle-icon">
        <i
          class="icon"
          :class="isCollapse ? 'icon-weibiaoti25' : 'icon-weibiaoti26'"
          @click="toggleMenu"
        ></i>
      </div>
      <div>
        <div class="user-name">
          <!-- <span class="wallet-icon"><i class="icon icon-qianbao-5"></i>钱包</span> -->
          <img src="@/assets/img/defaultHead.png" class="headLogo" alt="" />{{
            loginInfo.name
          }}
        </div>
        <img @click="loginOut" src="@/assets/img/loginOut.png" alt="" />
        <span @click="loginOut" class="login-out">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import {
  setStorageItem,
  getStorageItem,
  removeStorageItem,
  delCookie,
  getCookie,
} from '@/utils'

export default {
  name: 'AppHeader',
  data() {
    return {
      loginInfo: {},
    }
  },
  created() {
    this.getLoginInfo()
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse
    },
  },
  methods: {
    // 切换左侧菜单
    toggleMenu() {
      const flag = this.$store.state.isCollapse
      this.$store.commit('changeMenuToggle', !flag)
    },
    loginOut() {
      this.$confirm('确定退出当前账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          Api.user
            .loginOut()
            .then((res) => {
              if (res.retCode === statusCode.SUCCESS) {
                if (location.href.includes(window.managment_redirectUrl.admin)) {
                  // 测试环境
                  // delCookie('zxadmintoken', '.zhixinblockchain.com')
                  delCookie('zxadmintoken', window.location.host)
                } else {
                  // 本地
                  delCookie('zxadmintoken') // 兼容本地调试
                }
                removeStorageItem('loginInfo')
                this.$message({
                  showClose: true,
                  message: '退出成功',
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.$router.push({
                      name: 'login',
                    })
                  },
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.retMsg,
                  type: 'error',
                })
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    getLoginInfo() {
      // 判断是否已经登陆，检查token信息
      if (!getCookie('zxadmintoken')) {
        return
      }
      Api.user
        .getLoginInfo()
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            this.loginInfo = res.detail
            // setStorageItem('loginInfo', res.detail)
          } else {
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
//  .header{
//      width: 100%;
//      height: 70px;
//      background-color: #152857;
//      display: flex;
//      align-items: center;
//      justify-content: space-between;
//      .img{
//          margin-left: 50px;
//      }
//      .user-info{
//          margin-right: 30px;
//          font-size: 14px;
//          color: #ffffff;
//          .user-name{
//              margin-right: 30px;
//          }
//          img{
//              padding-right: 10px;
//              vertical-align: middle;
//              cursor: pointer;
//          }
//          .login-out{
//              cursor: pointer;
//          }
//      }
//  }
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .user-info {
    margin-right: 30px;
    font-size: 14px;
    color: #385abd;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .toggle {
      margin-left: 20px;
    }
    .toggle-icon {
      padding-left: 30px;
      box-sizing: border-box;
      .icon {
        font-size: 16px;
        cursor: pointer;
      }
    }
    .user-name {
      display: inline-block;
      margin-right: 30px;

      .wallet-icon {
        i {
          font-size: 20px;
          margin-right: 3px;
        }
        cursor: pointer;
        margin-right: 25px;
      }
    }
    img {
      padding-right: 10px;
      vertical-align: middle;
      cursor: pointer;
    }
    .login-out {
      cursor: pointer;
    }
  }
}
</style>
